/**
 * @author Daniel Aguirre
 * @file constants.js
 * @description Educational category Constants
 */

// Generic actions
export const GET_ALL_EDUCATIONAL_CATEGORIES =
  'Profile/GET_ALL_EDUCATIONAL_CATEGORIES';
export const GET_EDUCATIONAL_CATEGORY_BY_ID =
  'Profile/GET_EDUCATIONAL_CATEGORY_BY_ID';
export const CREATE_EDUCATIONAL_CATEGORY =
  'Profile/CREATE_EDUCATIONAL_CATEGORY';
export const UPDATE_EDUCATIONAL_CATEGORY =
  'Profile/UPDATE_EDUCATIONAL_CATEGORY';
export const DELETE_EDUCATIONAL_CATEGORY_BY_ID =
  'Profile/DELETE_EDUCATIONAL_CATEGORY_BY_ID';
